import { formatISO } from 'date-fns';

export interface SetInvoicingPeriod {
  invoiceFrom: Date | null;
  invoiceTo?: Date | null;
}

export interface SetInvoicingPeriodEncoded {
  invoiceFrom: string | null;
  invoiceTo: string | null;
}

export function encodeInvoicingPeriod(
  data: SetInvoicingPeriod,
): SetInvoicingPeriodEncoded {
  return {
    invoiceFrom: data.invoiceFrom
      ? formatISO(data.invoiceFrom, { representation: 'date' })
      : null,
    invoiceTo: data.invoiceTo
      ? formatISO(data.invoiceTo, { representation: 'date' })
      : null,
  };
}
